import { render, staticRenderFns } from "./sent_mail.vue?vue&type=template&id=0d4b5852&scoped=true&"
import script from "./sent_mail.vue?vue&type=script&lang=js&"
export * from "./sent_mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b5852",
  null
  
)

export default component.exports